module.exports = __webpack_public_path__ + "static/media/11.98893b65.png";